import { Component, OnInit, Output, EventEmitter, Input, NgZone, Renderer2, ChangeDetectorRef } from '@angular/core';
import { GlobalsService } from '../../../shared/services/globals.service';
import { DispatchBoardService } from '../../../shared/services/dispatch-board.service';
import { DispatchBoardSearch } from '../../../shared/models/DispatchBoardSearch';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { NotificationSettings } from '@progress/kendo-angular-notification';
import { CommonValues } from '../../../shared/static/CommonValues';
import { State, process, DataResult } from "@progress/kendo-data-query";
import { take, tap } from 'rxjs/operators';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { SortDescriptor, orderBy } from "@progress/kendo-data-query";
import * as _ from 'lodash';
import { PersonBus } from '../../../shared/models/PersonBus';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';

const tableRow = (node) => node.tagName.toLowerCase() === "tr";

const closest = (node, predicate) => {
    while (node && !predicate(node)) {
        node = node.parentNode;
    }

    return node;
};

@Component({
	selector: 'cp-dispatch-view-builder',
	templateUrl: './dispatch-view-builder.component.html',
	styleUrls: ['./dispatch-view-builder.component.scss']
})
export class DispatchViewBuilderComponent implements OnInit {

    selectedView: any;
	boardViewStatuses: any;
    boardViewResources: any[];
    boardViewResourcesSelected: any;
    boardViewResourcesUnSelected: any[];
    selectedResource: any;
    boardViewStatusesUnSelected: any[];
    selectedStatus: any;
    addResourceDialog: boolean = false;
    viewName: string = '';
    isGlobal: boolean = false;
    isActive: boolean = false;
    isDefault: boolean = false;
    dispatchViewDesc: string = '';

    selectedViewStatuses: any = [];
    selectedViewResources: any = [];
    statusesSelection : string[]=[];
    resourcesSelection: string[] = [];

    boardViews: any;

    subscriptions: Subscription[] = [];

    public sort: SortDescriptor[] = [
        {
            field: "sortOrder",
            dir: "asc",
        },
    ];
    public selectableSettings = {
        checkboxOnly: false,
        mode: 'single',
        drag: false,
    };
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService, private cd: ChangeDetectorRef, private renderer: Renderer2, private zone: NgZone) {
	}

    @Output() titleChild = new EventEmitter<string>();
    @Output() cancel = new EventEmitter();

    sch: DispatchBoardSearch = new DispatchBoardSearch(null);
    searchParam: DispatchBoardSearch;

	ngOnInit() {
        this.titleChild.emit('View Builder');
        this.getData();
    }

    getData() {
        this.searchParam = this.sch;
        this.searchParam.userId = this.svc_globals.userId;
     //   this.boardViews = this.svc_data.boardViews;

        this.svc_data.GetDispatchBoardViews().subscribe(data => {
            this.svc_data.boardViews = data;
            this.boardViews = data

        })
        this.svc_data.GetAllPeople().subscribe(data => {
            data.forEach((resource) => {
                resource.isSelected = false;
                resource.sortOrder = 100000;
            });
            this.svc_data.allPeople = data;
            this.boardViewResources = this.svc_data.allPeople.filter(t => t.isActive && t.legalName && t.legalName.length > 0 && t.companyId.toLowerCase() === CommonValues.DefaultCompanyId).sort((a, b) => {
                let fa = a.orderValue,
                    fb = b.firstName.toLowerCase();

                if (a.orderValue < b.orderValue) {
                    return -1;
                }
                if (a.orderValue > b.orderValue) {
                    return 1;
                }
                if (a.lastName < b.lastName) {
                    return -1;
                }
                if (a.lastName > b.lastName) {
                    return 1;
                }
                if (a.legalName < b.legalName) {
                    return -1;
                }
                if (a.legalName > b.legalName) {
                    return 1;
                }
                return 0;
            })
            this.boardViewResourcesUnSelected = this.boardViewResources.filter(r => r.isSelected == false);

            if (data.error) {
                alert('got an error back!');
            }
        });
        this.svc_data.GetAllStatuses().subscribe(data => {
            data.forEach((status) => {
                status.isSelected = false;
                status.sortOrder = 100000;
            });
            this.svc_data.allStatuses = data;

            this.boardViewStatuses = this.svc_data.allStatuses.sort((a, b) => {

                if (a.sortOrder && b.sortOrder) {
                    if (a.sortOrder < b.sortOrder) {
                        return -1;
                    }
                    if (a.sortOrder > b.sortOrder) {
                        return 1;
                    }
                }

                if (a.dispatchStatusName < b.dispatchStatusName) {
                    return -1;
                }
                if (a.dispatchStatusName > b.dispatchStatusName) {
                    return 1;
                }
                return 0;
            });

            if (data.error) {
                alert('got an error back!');
            }

            this.gridBoardViewStatuses = process(this.boardViewStatuses, this.state);
            this.boardViewStatusesUnSelected = this.boardViewStatuses.filter(r => r.isSelected == false);

        });
        //this.boardViewTechs = this.svc_data.boardPersonsData;
    }

    selectBoardView(view) {
        this.selectedViewStatuses = [];
        this.selectedViewResources = [];
        this.selectedView = view;

        this.svc_data.GetDispatchBoardViewStatuses(view.dispatchViewId).subscribe(data => {

            if (data.error) {
                alert('error getting Statuses');
            }
            this.boardViewStatuses.forEach(resource => {

                resource.isSelected = false;
                resource.sortOrder = 100000;
            });
            this.statusesSelection = [];
            data.forEach(status => {
                let index = this.boardViewStatuses.map(s => s.dispatchStatusId).indexOf(status.dispatchStatusId);
                if (index >= 0) {
                    this.boardViewStatuses[index].isSelected = true;
                    this.boardViewStatuses[index].sortOrder = status.sortOrder;
                } else {
                }
            });
            this.sortLists();
            this.boardViewStatusesUnSelected = this.boardViewStatuses.filter(r => r.isSelected == false);

        });
        this.svc_data.GetDispatchBoardViewPersons(view.dispatchViewId).subscribe(data => {
            console.log('View Resources: ' + JSON.stringify(data));

            if (data.error) {
                alert('error getting Resources');
            }
            this.resourcesSelection = [];
            this.boardViewResources.forEach(resource => {

                        resource.isSelected = false;
                resource.sortOrder = 100000;
            });
            data.forEach(resource => {
                let index = this.boardViewResources.map(s => s.personId).indexOf(resource.personId);
                if (index >= 0) {
                    this.boardViewResources[index].isSelected = true;
                    this.boardViewResources[index].sortOrder = resource.sortOrder;
                } else {
                }
            });
            this.sortLists();
            this.boardViewResourcesUnSelected = this.boardViewResources.filter(r => r.isSelected == false);
        });

        this.viewName = this.selectedView.dispatchViewName;
        this.dispatchViewDesc = this.selectedView.dispatchViewDesc;
        this.isActive = this.selectedView.isActive;
        this.isGlobal = this.selectedView.isGlobal;
        this.isDefault = this.selectedView.dispatchViewId == this.svc_data.defaultView ? true : false;
    }

    onResourceCheckboxChange(e, index) {

        this.boardViewResources[index].isSelected = !this.boardViewResources[index].isSelected;
        if (this.boardViewResources[index].isSelected === false) {
            this.boardViewResources[index].sortOrder = 100000;
        }

        this.reNumberOrder();
        this.sortLists();
    }

    public resourceRowCallback(context: RowClassArgs) {
        const isSelected = this.boardViewResources ? this.boardViewResources.findIndex((element) => { return element.personId == this.resourceRowSelection }) == context.index : false;
        const isNotSelected = this.boardViewResources ? this.boardViewResources.findIndex((element) => { return element.personId == this.resourceRowSelection }) != context.index : false;
        return {
            test: isSelected,
            badSelected: isNotSelected
        };
    }

    onStatusCheckboxChange(e, index) {

        this.boardViewStatuses[index].isSelected = !this.boardViewStatuses[index].isSelected;//e.currentTarget.checked;

        //this.gridBoardViewStatuses = { data: [], total: 0 };

        if (this.boardViewStatuses[index].isSelected === false) {
            this.boardViewStatuses[index].sortOrder = 100000;
        }
        this.reNumberOrder();
        this.sortLists();

        this.boardViewStatuses.forEach((item, index) => {
            if (item.sortOrder === 100000) {
                item.isSelected = false;
            }
        });

        //this.gridBoardViewStatuses = { data: this.boardViewStatuses, total: this.boardViewStatuses.length };
        //this.gridBoardViewStatuses = process(this.boardViewStatuses, this.state);

        this.cd.detectChanges();

        //this.selectedViewStatuses = this.gridBoardViewStatuses.data.filter(r => r.isSelected == true);

    }
    getStatusChecked(index) {
        return this.boardViewStatuses ? this.boardViewStatuses[index] : false;
    }
    public statusRowCallback(context: RowClassArgs) {
        const isSelected = this.boardViewStatuses ? this.boardViewStatuses.findIndex((element) => { return element.dispatchStatusId == this.statusRowSelection }) == context.index : false;
        const isNotSelected = this.boardViewStatuses ? this.boardViewStatuses.findIndex((element) => { return element.dispatchStatusId == this.statusRowSelection }) != context.index : false;
        return {
            test: isSelected,
            badSelected: isNotSelected
        };
    }

    statusRowSelection: string;
    canShiftStatusRow: boolean = false;
    statusRowSelected(e) {

        this.statusRowSelection = ((e.selectedRows && e.selectedRows[0] && e.selectedRows[0].dataItem) ? e.selectedRows[0].dataItem.dispatchStatusId : "");
        if (this.statusRowSelection.length > 0 && (e.selectedRows && e.selectedRows[0] && e.selectedRows[0].dataItem && e.selectedRows[0].dataItem.isSelected)) {
            this.canShiftStatusRow = true;
        } else {
            this.canShiftStatusRow = false;
        }
    }

    shiftStatusRow(statusId: string, shiftUp: boolean = true, shiftAmount: number = 1) {
        if (statusId) {
            let index = this.boardViewStatuses.findIndex((element) => { return element.dispatchStatusId == statusId });
            if (index>=0) {
                switch (shiftUp) {
                    case true:
                        //this.boardViewStatuses[index].sortOrder = this.boardViewStatuses[index].sortOrder - (shiftAmount > 1 ? index : 1);
                        //index > 0 ? this.boardViewStatuses[index - (shiftAmount > 1 ? index : 1)].sortOrder + (shiftAmount > 1 ? index : 1) : null;
                        if (index > 0 && this.selectedViewStatuses.length>1) {
                            if (index > 0) {
                                this.boardViewStatuses[index].sortOrder--;
                                this.boardViewStatuses[index - 1].sortOrder++ ;
                            }
                        }
                        break;
                    case false:
                        //this.boardViewStatuses[index].sortOrder = this.boardViewStatuses[index].sortOrder + (shiftAmount > 1 ? index : 1);
                        //index > 0 ? this.boardViewStatuses[index + (shiftAmount > 1 ? index : 1)].sortOrder - (shiftAmount > 1 ? index : 1) : null;
                        if (index < this.selectedViewStatuses.length - 1) {
                            if (index < this.boardViewStatuses.length - 1) {

                                this.boardViewStatuses[index].sortOrder++
                                this.boardViewStatuses[index + 1].sortOrder--
                            }
                        }
                        break;
                    default:
                        return null;
                }
            }
        }
        this.sortLists();

    }

    resourceRowSelection: string;
    canShiftResourceRow: boolean = false;
    resourceRowSelected(e) {

        this.resourceRowSelection = ((e.selectedRows && e.selectedRows[0] && e.selectedRows[0].dataItem) ? e.selectedRows[0].dataItem.personId : "");
        if (this.resourceRowSelection.length > 0 && (e.selectedRows && e.selectedRows[0] && e.selectedRows[0].dataItem && e.selectedRows[0].dataItem.isSelected)) {
            this.canShiftResourceRow = true;
        } else {
            this.canShiftResourceRow = false;
        }
    }
    addResource() {

        var index = this.boardViewResources.findIndex(a => a.personId == this.selectedResource);
        var nextPos = this.selectedViewResources.length + 1;
        this.boardViewResources[index].isSelected = true;
        this.boardViewResources[index].sortOrder = nextPos;
        this.selectedResource = null;
        this.addResourceDialog = false;
        this.sortLists();
        this.boardViewResourcesUnSelected = this.boardViewResources.filter(r => r.isSelected == false);

    }
    addStatus() {

        var index = this.boardViewStatuses.findIndex(a => a.dispatchStatusId == this.selectedStatus);
        var nextPos = this.selectedViewStatuses.length + 1;
        this.boardViewStatuses[index].isSelected = true;
        this.boardViewStatuses[index].sortOrder = nextPos;
        this.selectedStatus = null;
        this.sortLists();
        this.boardViewStatusesUnSelected = this.boardViewStatuses.filter(r => r.isSelected == false);

    }
    shiftResourceRow(resourceId: string, shiftUp: boolean = true, shiftAmount: number = 1) {
        if (resourceId) {
            let index = this.boardViewResources.findIndex((element) => { return element.personId == resourceId });
            if (index>=0) {
                switch (shiftUp) {
                    case true:
                        //this.boardViewStatuses[index].sortOrder = this.boardViewStatuses[index].sortOrder - (shiftAmount > 1 ? index : 1);
                        //index > 0 ? this.boardViewStatuses[index - (shiftAmount > 1 ? index : 1)].sortOrder + (shiftAmount > 1 ? index : 1) : null;
                        if (index > 0 && this.selectedViewResources.length > 1) {
                            if (index > 0) {
                                this.boardViewResources[index].sortOrder--;
                                this.boardViewResources[index - 1].sortOrder++;
                            }
                        }
                        break;
                    case false:
                        //this.boardViewStatuses[index].sortOrder = this.boardViewStatuses[index].sortOrder + (shiftAmount > 1 ? index : 1);
                        //index > 0 ? this.boardViewStatuses[index + (shiftAmount > 1 ? index : 1)].sortOrder - (shiftAmount > 1 ? index : 1) : null;
                        if (index < this.selectedViewResources.length - 1) {
                            if (index < this.boardViewStatuses.length - 1) {

                                this.boardViewResources[index].sortOrder++
                                this.boardViewResources[index + 1].sortOrder--
                            }
                        }
                        break;
                    default:
                        return null;
                }
            }
        }
        this.sortLists();

    }
    sortSelectedResourceList() {
        this.selectedViewResources.sort((a, b) => {

                    if (a.sortOrder < b.sortOrder) {
                        return -1;
                    }
                    if (a.sortOrder > b.sortOrder) {
                        return 1;
            }
            return 0;
        });

    }
    sortSelectedStatusList() {
        this.selectedViewStatuses.sort((a, b) => {

            if (a.sortOrder < b.sortOrder) {
                return -1;
            }
            if (a.sortOrder > b.sortOrder) {
                return 1;
            }
            return 0;
        });

    }
    sortLists() {
        this.boardViewResources.sort((a, b) => {

            if (a.sortOrder < 100000 && b.sortOrder == 100000) {
                return -1;
            }
            if (a.sortOrder == 100000 && b.sortOrder < 100000) {
                return 1;
            }
            if (a.sortOrder < 100000 && b.sortOrder < 100000) {

                if (a.sortOrder && b.sortOrder) {
                    if (a.sortOrder < b.sortOrder) {
                        return -1;
                    }
                    if (a.sortOrder > b.sortOrder) {
                        return 1;
                    }
                }
            }
            if (a.sortOrder == 100000 && b.sortOrder == 100000)
            {
                //if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
                //    return -1;
                //}
                //if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
                //    return 1;
                //}
                if (a.legalName.toLowerCase() < b.legalName.toLowerCase()) {
                    return -1;
                }
                if (a.legalName.toLowerCase() > b.legalName.toLowerCase()) {
                    return 1;
                }
                return 0;
            }
        });
        this.selectedViewResources = this.boardViewResources.filter(r => r.isSelected == true);
        this.sortSelectedResourceList();
        this.boardViewStatuses.sort((a, b) => {

            if (a.sortOrder < 100000 && b.sortOrder == 100000) {
                return -1;
            }
            if (a.sortOrder == 100000 && b.sortOrder < 100000) {
                return 1;
            }
            if (a.sortOrder < 100000 && b.sortOrder < 100000) {

                if (a.sortOrder && b.sortOrder) {
                    if (a.sortOrder < b.sortOrder) {
                        return -1;
                    }
                    if (a.sortOrder > b.sortOrder) {
                        return 1;
                    }
                }
            }
            if (a.sortOrder == 100000 && b.sortOrder == 100000) {
                if (a.dispatchStatusName.toLowerCase() < b.dispatchStatusName.toLowerCase()) {
                    return -1;
                }
                if (a.dispatchStatusName.toLowerCase() > b.dispatchStatusName.toLowerCase()) {
                    return 1;
                }
                return 0;
            }
        });
        this.selectedViewStatuses = this.boardViewStatuses.filter(r => r.isSelected == true);
        this.sortSelectedStatusList()

        //this.boardViewResourcesSelected =
    }
    alphaSortStatus() {

        this.boardViewStatuses.sort((a, b) => {

            if (a.sortOrder < 100000 && b.sortOrder == 100000) {
                return -1;
            }
            if (a.sortOrder == 100000 && b.sortOrder < 100000) {
                return 1;
            }
            if (a.sortOrder < 100000 && b.sortOrder < 100000) {

                if (a.dispatchStatusName.toLowerCase() < b.dispatchStatusName.toLowerCase()) {
                    return -1;
                }
                if (a.dispatchStatusName.toLowerCase() > b.dispatchStatusName.toLowerCase()) {
                    return 1;
                }
                return 0;
            }
            if (a.sortOrder == 100000 && b.sortOrder == 100000) {
                //if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
                //    return -1;
                //}
                //if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
                //    return 1;
                //}
                if (a.dispatchStatusName.toLowerCase() < b.dispatchStatusName.toLowerCase()) {
                    return -1;
                }
                if (a.dispatchStatusName.toLowerCase() > b.dispatchStatusName.toLowerCase()) {
                    return 1;
                }
                return 0;
            }
        });
        let resourceCount = 1;
        for (let i = 0; i < this.boardViewStatuses.length; i++) {
            if (this.boardViewStatuses[i].isSelected) {
                this.boardViewStatuses[i].sortOrder = resourceCount;
                resourceCount++;
            } else {
                this.boardViewStatuses[i].sortOrder = 100000;
            }
        }
        this.selectedViewStatuses = this.boardViewStatuses.filter(r => r.isSelected == true);

    }
    alphaSortResources() {
        this.boardViewResources.sort((a, b) => {

            if (a.sortOrder < 100000 && b.sortOrder == 100000) {
                return -1;
            }
            if (a.sortOrder == 100000 && b.sortOrder < 100000) {
                return 1;
            }
            if (a.sortOrder < 100000 && b.sortOrder < 100000) {

                if (a.legalName.toLowerCase() < b.legalName.toLowerCase()) {
                    return -1;
                }
                if (a.legalName.toLowerCase() > b.legalName.toLowerCase()) {
                    return 1;
                }
                return 0;
            }
            if (a.sortOrder == 100000 && b.sortOrder == 100000) {
                //if (a.lastName.toLowerCase() < b.lastName.toLowerCase()) {
                //    return -1;
                //}
                //if (a.lastName.toLowerCase() > b.lastName.toLowerCase()) {
                //    return 1;
                //}
                if (a.legalName.toLowerCase() < b.legalName.toLowerCase()) {
                    return -1;
                }
                if (a.legalName.toLowerCase() > b.legalName.toLowerCase()) {
                    return 1;
                }
                return 0;
            }
        });
        let resourceCount = 1;
        for (let i = 0; i < this.boardViewResources.length; i++) {
            if (this.boardViewResources[i].isSelected) {
                this.boardViewResources[i].sortOrder = resourceCount;
                resourceCount++;
            } else {
                this.boardViewResources[i].sortOrder = 100000;
            }
        }
        this.selectedViewResources = this.boardViewResources.filter(r => r.isSelected == true);
    }
    reNumberOrder() {
        let resourceCount = 1;
        for (let i = 0; i < this.boardViewResources.length; i++) {
            if (this.boardViewResources[i].isSelected) {
                this.boardViewResources[i].sortOrder = resourceCount;
                resourceCount++;
            } else {
                this.boardViewResources[i].sortOrder = 100000;
            }
        }
        let statusCount = 1;
        for (let i = 0; i < this.boardViewStatuses.length; i++) {
            if (this.boardViewStatuses[i].isSelected) {
                this.boardViewStatuses[i].sortOrder = statusCount;
                statusCount++;
            } else {
                this.boardViewStatuses[i].sortOrder = 100000;
            }
        }

        this.sortLists();
    }

    cancelClick() {
        this.cancel.emit(null);
    }
    saveView() {
        let saveObj: DispatchBoardSearch = new DispatchBoardSearch(null);
        saveObj.isActive = this.isActive;
        saveObj.isGlobal = this.isGlobal;

        if (this.selectedView) { saveObj.dispatchViewId = this.selectedView.dispatchViewId;}
        else {
            saveObj.dispatchViewId = CommonValues.Guid_Empty;
        }

   //     saveObj.dispatchViewId = this.selectedView.dispatchViewId;
        saveObj.isDefault = this.isDefault;
        saveObj.dispatchViewName = this.viewName;
        saveObj.dispatchViewDesc = this.dispatchViewDesc;
        saveObj.boardStatuses = this.selectedViewStatuses.map(s => s.dispatchStatusId);
        saveObj.boardPersons = this.selectedViewResources.map(s => s.personId);

        this.svc_data.SaveDispatchBoardView(saveObj).subscribe((data: any) => {

            if (data.saveError || data.hasPrimaryReturn == false) {
                this.notify(data.messages[0].message, 'E', true,null);
            }
            else {
                this.notify("Saved View Successfully", "S", false, null);
                this.getData();
                this.cancelClick();
            }

        });
    }

    public state: State = {
        skip: 0,
        take: 10000,
    };
    gridBoardViewStatuses: DataResult;
    private currentSubscription: Subscription;
    public dataStateChange(state: State): void {
        this.state = state;
        this.gridBoardViewStatuses = process(this.boardViewStatuses, this.state);
        this.currentSubscription.unsubscribe();
        this.zone.onStable
            .pipe(take(1))
            .subscribe(() => (this.currentSubscription = this.handleDragAndDrop()));
    }

    public rowCallback(context: RowClassArgs) {
        return {
            dragging: context.dataItem.dragging,
        };
    }

    private handleDragAndDrop(): Subscription {
        const sub = new Subscription(() => { });
        let draggedItemIndex;

        const tableRows = Array.from(document.querySelectorAll(".k-grid tr"));
        tableRows.forEach((item) => {
            this.renderer.setAttribute(item, "draggable", "true");
            const dragStart = fromEvent<DragEvent>(item, "dragstart");
            const dragOver = fromEvent(item, "dragover");
            const dragEnd = fromEvent(item, "dragend");

            sub.add(
                dragStart
                    .pipe(
                        tap(({ dataTransfer }) => {
                            try {
                                const dragImgEl = document.createElement("span");
                                dragImgEl.setAttribute(
                                    "style",
                                    "position: absolute; display: block; top: 0; left: 0; width: 0; height: 0;"
                                );
                                document.body.appendChild(dragImgEl);
                                dataTransfer.setDragImage(dragImgEl, 0, 0);
                            } catch (err) {
                                // IE doesn't support setDragImage
                            }
                            try {
                                // Firefox won't drag without setting data
                                dataTransfer.setData("application/json", "");
                            } catch (err) {
                                // IE doesn't support MIME types in setData
                            }
                        })
                    )
                    .subscribe(({ target }) => {
                        const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                        draggedItemIndex = row.rowIndex;
                        const dataItem = this.gridBoardViewStatuses.data[draggedItemIndex];
                        dataItem.dragging = true;
                    })
            );

            sub.add(
                dragOver.subscribe((e: any) => {
                    e.preventDefault();
                    const dataItem = this.gridBoardViewStatuses.data.splice(draggedItemIndex, 1)[0];
                    const dropIndex = closest(e.target, tableRow).rowIndex;
                    const dropItem = this.gridBoardViewStatuses.data[dropIndex];

                    draggedItemIndex = dropIndex;
                    this.zone.run(() =>
                        this.gridBoardViewStatuses.data.splice(dropIndex, 0, dataItem)
                    );
                })
            );

            sub.add(
                dragEnd.subscribe((e: any) => {
                    e.preventDefault();
                    const dataItem = this.gridBoardViewStatuses.data[draggedItemIndex];
                    dataItem.dragging = false;
                })
            );
        });

        return sub;
    }
    showAddResourceDialog() {
        this.selectedResource = null;
        this.boardViewResourcesUnSelected = this.boardViewResources.filter(r => r.isSelected == false);
        this.addResourceDialog = true;

    }

    notify(notification: string, type: string = "E", closable: boolean = false, settings: NotificationSettings = { content: '', hideAfter: 2000 }) {
        this.svc_globals.notify(notification, type, closable, settings);
    }
}